define('app/editor/dialogs/FollowReportDialogView',['require','./SaveDialogView','app/app','glu/dialog','hbs!./FollowReportDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('./SaveDialogView'),
		APP = require('app/app'),
		dialog = require('glu/dialog');

	var view = SaveDialogView.extend({

		dialogTitle: 'Follow Report',

		getClass: function() {
			return 'modal-follow-report';
		},

		template: require('hbs!./FollowReportDialogView.hbs'),

		ui: {
			$frequency: '[name="frequency"]'
		},

		getButtons: function() {
			var output = [],
				distrData = this.model.getDistrData();

			if (distrData && distrData.schedule !== 'NONE') {
				output.push({
					text: 'Update Preferences',
					callback: 'setFollowSchedule',
					className: 'btn-primary'
				});
				output.push({
					text: 'Stop Following',
					callback: 'setUnfollowSchedule',
					className: 'btn-secondary'
				});
			} else {
				output.push({
					text: 'Follow',
					callback: 'setFollowSchedule',
					className: 'btn-primary'
				});
			}

			output.push({
				text: 'Cancel',
				callback: 'cancelCallback',
				className: 'btn-link'
			});

			return output;
		},

		onRender: function() {
			this.ui.$frequency.comboBox();
		},

		isAttachCsv: function() {
			var distrData = this.model.getDistrData();
			return distrData && distrData.form && distrData.form === 'CSV';
		},

		isDaily: function() {
			var data = this.model.getDistrData();
			if (data && data.schedule === 'DAILY') {
				return true;
			}
		},

		isWeekly: function() {
			var data = this.model.getDistrData();
			if (data && data.schedule === 'WEEKLY') {
				return true;
			}
		},

		isMonthly: function() {
			var data = this.model.getDistrData();
			if (data && data.schedule === 'MONTHLY') {
				return true;
			}
		},

		setFollowSchedule: function() {
			var self = this,
				payload = {
					messageType: 'EMAIL',
					//dataForm: self.$(self.ui.$attachCsv).prop('checked') ? 'CSV' : 'LINK',
					dataForm: 'CSV',
					reportId: self.model.id,
					schedule: self.ui.$frequency.val(),
					recipients: [APP.user.getUsername()]
				};

			self.model.setFollowSchedule(payload);
			dialog.close();
		},

		setUnfollowSchedule: function() {
			var self = this,
				payload = {
					messageType: 'EMAIL',
					dataForm: 'CSV',
					reportId: self.model.id,
					schedule: 'NONE',
					recipients: [APP.user.getUsername()]
				};

			self.model.setFollowSchedule(payload);
			dialog.close();
		},

		cancelCallback: function() {
			dialog.close();
		}
	});

	return view;
});

